import { render } from "./Payments.vue?vue&type=template&id=000ccc80"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
script.render = render

export default script